import styled from 'styled-components';

import { Spacer } from '@ontruck/orc';

const StyledQuantitySubTag = styled(Spacer).attrs(() => ({ mBottom: '0' }))`
  font-weight: bold;
  font-size: ${(props) => props.theme.base.textSizes.M};
  color: var(--greyWolf);
`;

export default StyledQuantitySubTag;
